import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export enum PayoutAccountTypes {
  Paypal = 'paypal',
  Iban = 'iban',
  Bank = 'bank',
}

export enum PayoutTypes {
  Default = 'default',
  Listing = 'listing',
  None = 'none',
}

export interface PayoutMethod {
  accountDetails: string;
  accountName: string;
  accountType: PayoutAccountTypes;
  actualPayoutDate?: string;
  expectedPayoutDate?: string;
  methodGUID: string;
  type: PayoutTypes;
}

export type GetPaymentMethodProps = {
  listingId: number;
  paymentRequestID: string;
  userId: number;
};

/* istanbul ignore next */
export default (makeCall: MakeCall) => ({
  listingId,
  paymentRequestID,
  userId,
}: GetPaymentMethodProps): Promise<{ data: PayoutMethod }> =>
  makeCall<PayoutMethod>(
    'GET',
    `/v1/user/${userId}/payout/${paymentRequestID}/${listingId}`,
  );
